module.exports = __webpack_public_path__ + "media/images/views/home/home-features-photo-6-d72b080e23a54417bccecd29e7d0d340.png";